import React from "react";

function WhoAreWe() {
  return <section className="w-screen h-screen">Hello World</section>;
}

export default WhoAreWe;
